import { useLingui } from '@lingui/react/macro';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router';

import {
  ABOUT_IFU_PDF_URLS,
  FR_CA_ABOUT_IFU_PDF_URLS,
} from '../../common-components/composed/pdfReader/pdfConstants';
import { FRENCH_LOCALES } from '../../locales/helpers';

import About from './About';

const AboutRouter: React.FC = () => {
  const { i18n } = useLingui();
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/VDA_ABOUT`}>
        <About
          pdfName="VDA_ABOUT"
          pdfUrl={
            FRENCH_LOCALES.includes(i18n.locale)
              ? FR_CA_ABOUT_IFU_PDF_URLS.VDA_ABOUT
              : ABOUT_IFU_PDF_URLS.VDA_ABOUT
          }
        />
      </Route>
      <Route path={`${path}/VPA_ABOUT`}>
        <About
          pdfName="VPA_ABOUT"
          pdfUrl={
            FRENCH_LOCALES.includes(i18n.locale)
              ? FR_CA_ABOUT_IFU_PDF_URLS.VPA_ABOUT
              : ABOUT_IFU_PDF_URLS.VPA_ABOUT
          }
        />
      </Route>
      <Route path={`${path}/VDA_IFU`}>
        <About
          pdfName="VDA_IFU"
          pdfUrl={
            FRENCH_LOCALES.includes(i18n.locale)
              ? FR_CA_ABOUT_IFU_PDF_URLS.VDA_IFU
              : ABOUT_IFU_PDF_URLS.VDA_IFU
          }
        />
      </Route>
      <Route path={`${path}/VPA_IFU`}>
        <About
          pdfName="VPA_IFU"
          pdfUrl={
            FRENCH_LOCALES.includes(i18n.locale)
              ? FR_CA_ABOUT_IFU_PDF_URLS.VPA_IFU
              : ABOUT_IFU_PDF_URLS.VPA_IFU
          }
        />
      </Route>
      <Route path={`${path}/DSS_IFU`}>
        <About
          pdfName="DSS_IFU"
          pdfUrl={
            FRENCH_LOCALES.includes(i18n.locale)
              ? FR_CA_ABOUT_IFU_PDF_URLS.DSS_IFU
              : ABOUT_IFU_PDF_URLS.DSS_IFU
          }
        />
      </Route>
      <Route path={`${path}/SEG_IFU`}>
        <About
          pdfName="SEG_IFU"
          pdfUrl={
            FRENCH_LOCALES.includes(i18n.locale)
              ? FR_CA_ABOUT_IFU_PDF_URLS.SEG_IFU
              : ABOUT_IFU_PDF_URLS.SEG_IFU
          }
        />
      </Route>
      <Redirect to={`${path}/VDA_ABOUT`} />
    </Switch>
  );
};
export default AboutRouter;
